import $ from 'jquery';

class Curtain {

  constructor(curtain) {
    this.elm = curtain;
    this.button = $(`*[data-curtain-open="${curtain.id}"]`);
    this.mouseOver = false;
    console.log('ok');
  }

  checkMouseOver() {
    if (!this.mouseOver) {
      setTimeout(() => {

        if(!this.mouseOver) {
          this.deactivate();
        }
      }, 100);
    }
  }

  activate() {
    $('*[data-curtain].is-open').removeClass('is-open');
    $('*[data-curtain-open].is-active').removeClass('is-active');

    if (!$(this.elm).is('.is-open')) {
      $(this.elm).addClass('is-open');
      $(this.button).addClass('is-active');
    }
  }

  deactivate() {
    if ($(this.elm).is('.is-open')) {
      $(this.elm).removeClass('is-open');
      $(this.button).removeClass('is-active');
      $(this.button).off('mouseleave');
      $(this.elm).off('mouseenter mouseleave');
    }
  }
}

class CurtainControll {
  constructor() {
    this.activeCurtain = [];

    const curtains = $('*[data-curtain]');
    if (curtains.length) {
      curtains.each((index, curtain) => {
        this.activeCurtain[$(curtain).attr('id')] = new Curtain(curtain)
      });
    }

    $('*[data-curtain-open]')
      .on('mouseenter', event => {
        let targetId = $(event.target).data('curtain-open');
        let target = this.activeCurtain[targetId];

        if (target) {
          target.activate();
          target.mouseOver = true;
          target.checkMouseOver();

          $(event.target).on('mouseleave', event => {
            target.mouseOver = false;
            target.checkMouseOver();
          });

          $(target.elm)
            .on('mouseenter', event => {
              target.mouseOver = true;
              target.checkMouseOver();
            })
            .on('mouseleave', event => {
              target.mouseOver = false;
              target.checkMouseOver();
            });
        };
      });
  }
}

export default new CurtainControll;
